var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isFull)?[_c('nav-header',{staticClass:"fixed",attrs:{"id":"nav-header"}}),_c('div',{attrs:{"id":"view"}},[_c('router-view')],1),_c('nav-footer',{attrs:{"id":"nav-footer"}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }